import axios from 'axios';

const USE_MOCK = process.env.REACT_APP_USE_MOCK === 'true';

if (USE_MOCK) {
  console.info('[Mock mode] Running with dummy data. No backend required.');
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

import {
  authAPI    as mockAuthAPI,
  bikeAPI    as mockBikeAPI,
  bookingAPI as mockBookingAPI,
  promoAPI   as mockPromoAPI,
  reviewAPI  as mockReviewAPI,
  orderAPI   as mockOrderAPI,
  userAPI    as mockUserAPI,
} from './mock';

const realAuthAPI = {
  register: (data)  => api.post('/auth/register', data),
  login:    (data)  => api.post('/auth/login', data),
  logout:   ()      => api.post('/auth/logout'),
  getMe:    ()      => api.get('/auth/me'),
  updateMe: (data)  => api.put('/auth/me', data),
};

const realBikeAPI = {
  getAll:            (params)       => api.get('/bikes', { params }),
  getOne:            (id)           => api.get(`/bikes/${id}`),
  checkAvailability: (params)       => api.get('/bikes/availability', { params }),
  create:            (data)         => api.post('/bikes', data),
  update:            (id, data)     => api.put(`/bikes/${id}`, data),
  updateStatus:      (id, data)     => api.patch(`/bikes/${id}/status`, data),
  delete:            (id)           => api.delete(`/bikes/${id}`),
  uploadImages:      (id, formData) => api.post(`/bikes/${id}/images`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteImage:       (id, filename) => api.delete(`/bikes/${id}/images`, { data: { filename } }),
};

const realBookingAPI = {
  create:       (data)     => api.post('/bookings', data),
  getAll:       (params)   => api.get('/bookings', { params }),
  getMy:        (params)   => api.get('/bookings/my', { params }),
  getOne:       (id)       => api.get(`/bookings/${id}`),
  updateStatus: (id, data) => api.patch(`/bookings/${id}/status`, data),
  update:       (id, data) => api.put(`/bookings/${id}`, data),
  delete:       (id)       => api.delete(`/bookings/${id}`),
  getStats:     (params)   => api.get('/bookings/stats', { params }),
};

const realPromoAPI = {
  validate: (data)     => api.post('/promos/validate', data),
  getAll:   ()         => api.get('/promos'),
  create:   (data)     => api.post('/promos', data),
  update:   (id, data) => api.put(`/promos/${id}`, data),
  toggle:   (id)       => api.patch(`/promos/${id}/toggle`),
  delete:   (id)       => api.delete(`/promos/${id}`),
};

const realReviewAPI = {
  create:     (data)           => api.post('/reviews', data),
  getForBike: (bikeId, params) => api.get(`/reviews/bike/${bikeId}`, { params }),
  getMy:      ()               => api.get('/reviews/my'),
  update:     (id, data)       => api.put(`/reviews/${id}`, data),
  delete:     (id)             => api.delete(`/reviews/${id}`),
};

const realOrderAPI = {
  place: (data) => api.post('/orders', data),
};

const realUserAPI = {
  getAll:     (params)    => api.get('/users', { params }),
  getOne:     (id)        => api.get(`/users/${id}`),
  changeRole: (id, data)  => api.patch(`/users/${id}/role`, data),
  toggle:     (id)        => api.patch(`/users/${id}/toggle`),
  delete:     (id)        => api.delete(`/users/${id}`),
};

export const authAPI    = USE_MOCK ? mockAuthAPI    : realAuthAPI;
export const bikeAPI    = USE_MOCK ? mockBikeAPI    : realBikeAPI;
export const bookingAPI = USE_MOCK ? mockBookingAPI : realBookingAPI;
export const promoAPI   = USE_MOCK ? mockPromoAPI   : realPromoAPI;
export const reviewAPI  = USE_MOCK ? mockReviewAPI  : realReviewAPI;
export const orderAPI   = USE_MOCK ? mockOrderAPI   : realOrderAPI;
export const userAPI    = USE_MOCK ? mockUserAPI    : realUserAPI;
